import { ExternalLinkIcon } from '@panwds/icons';
import { classNames } from '@panwds/tailwindcss';
import React from 'react';
import { testIdGen } from '../../utils/index.js';
import { Body } from '../Typography/index.js';
/**
 * An anchor element styled properly.
 */
export function Link({ children, external = false, addClassName, dataMetrics, dataTestId, ...props }) {
    const attributes = {};
    if (external) {
        attributes['target'] = '_blank';
        attributes['rel'] = 'noreferrer';
    }
    attributes['data-testid'] = dataTestId || `link-${typeof children === 'string' && testIdGen(children)}`;
    const classes = classNames('tw-no-underline', 'hover:tw-text-blue-700 dark:hover:tw-text-blue-300', 'active:tw-text-blue-800 dark:active:tw-text-blue-200', addClassName);
    return (React.createElement(Body, { "data-metrics": dataMetrics, "data-testid": dataTestId || `link-${typeof children === 'string' && testIdGen(children)}`, ...attributes, ...props, as: "a", appearance: "link", addClassName: classes },
        children,
        external && React.createElement(ExternalLinkIcon, { size: "sm", "data-testid": "icon-external", className: "tw-ml-1" })));
}
//# sourceMappingURL=Link.js.map